module.exports.OPEN_FILE = 'OPEN_FILE';
module.exports.COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD';
module.exports.DELETE_FILE = 'DELETE_FILE';
module.exports.UPLOAD = 'UPLOAD';
module.exports.NEW_FILE = 'NEW_FILE';



// WEBPACK FOOTER //
// ./shared/constants.js